import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import dayjsRelativeTime from 'dayjs/plugin/relativeTime'
import advancedFormat from 'dayjs/plugin/advancedFormat'

class Dayjs {
  public dayjs: typeof dayjs
  public tzLocal: string
  public dateFormat: string

  constructor() {
    dayjs.extend(utc)
    dayjs.extend(timezone)
    dayjs.extend(dayjsRelativeTime)
    dayjs.extend(advancedFormat)

    this.dayjs = dayjs
    this.tzLocal = dayjs.tz.guess()
    this.dateFormat = 'YYYY-MM-DD HH:mm:ss'
  }

  setDefaultTz(timezone: string) {
    dayjs.tz.setDefault(timezone)
    this.tzLocal = timezone

    return this
  }

  setDateFormat(dateFormat: string) {
    this.dateFormat = dateFormat

    return this
  }

  convertDateTimeToTz({ date, time, tz }: Record<'date' | 'time' | 'tz', string>): dayjs.Dayjs {
    return dayjs.tz(`${date} ${time}`, tz)
  }

  getCurrentDateTimeInTz(tz: string): dayjs.Dayjs {
    return dayjs.tz(this.dayjs(), tz)
  }
}

export default new Dayjs()
